import moment from 'moment';
import 'react-native-get-random-values';
import {v4 as uuidv4} from 'uuid';

import {updateDataAtPath, logForCrashlytics} from 'src/Utils/fireUtils';
import {getReduxState} from './helpers';
import {Alert} from 'react-native';

// made this more generic
export const classicPhotoVideoCompletionEvent = ({
  challengeId,
  photoUrl,
  thumbnail = '',
  userId,
  groupId,
  eventId,
  shareUUID,
  description,
  challenge,
}) => {
  if (!challenge && __DEV__) {
    Alert.alert('No Challenge');
  }
  logForCrashlytics(
    'classicPhotoVideoCompletionEvent  fired in huntFunctions_v2.js',
  );

  eventId = eventId || getReduxState(['groupInfo', 'eventId']);

  userId = userId || getReduxState(['user', 'info', 'userId']);

  const isClassicHunt = getReduxState(['groupInfo', 'classic_hunt']);

  console.log('classicPhotoVideoCompletionEvent', {
    isClassicHunt,
  });

  if (groupId && challengeId) {
    const completeTime = Date.now();

    const path = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/completions/${userId}`;
    const params = {
      userId,
      answeredCorrectly: true,
      answeredAt: completeTime,
      photoUrl,
      thumbnail,
    };

    updateDataAtPath(path, params);

    const photoUrlPath = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/photoUrl`;
    const photoThumbPath = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/thumbnail`;
    const photoSharePath = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/shareUUID`;

    updateDataAtPath(photoUrlPath, photoUrl);
    updateDataAtPath(photoThumbPath, thumbnail);
    updateDataAtPath(photoSharePath, shareUUID);

    const completeTimePath = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${challengeId}/completeTime`;

    updateDataAtPath(completeTimePath, completeTime);

    const updatedIds = {
      groupId,
      eventId: eventId || null,
    };

    const email = getReduxState(['user', 'info', 'email']);
    const teamName = getReduxState(['groupInfo', 'teamName']);
    const is_test = email?.includes?.('@lets') || teamName?.includes?.('test');

    const photoPath = `photos/${groupId}/photos/${shareUUID}`;
    const photoCompletionObject = {
      shareUUID: shareUUID,
      groupId,
      eventId: eventId || null,
      userId,
      email,
      teamName,
      completionId: uuidv4(),
      challenge: description,
      type: 'Location Photo Challenge',
      date: Date.now(),
      is_test,
      dateFormated: moment().format('YYYY-MM-DDTHH:mm:ss.sssZ'),
      downloadURL: photoUrl,
      photoUrl,
      thumbnail,
      path: photoPath,
    };
    console.log({photoCompletionObject});

    updateDataAtPath(`photos/${groupId}`, updatedIds);

    updateDataAtPath(photoPath, photoCompletionObject);
  }
};

export const setHuntTimerStart = (groupId) => {
  logForCrashlytics('setHuntTimerStart fired in huntFunctions_v2.js');

  if (groupId) {
    const path = `scavengerhunt/completions/${groupId}/location_v2/timerStart`;
    const startTime = Date.now();
    console.log({path, startTime});

    updateDataAtPath(path, startTime);
  }
};

export const setHuntTimerFinish = (groupId) => {
  logForCrashlytics('setHuntTimerStart fired in huntFunctions_v2.js');

  if (groupId) {
    const path = `scavengerhunt/completions/${groupId}/location_v2/timerFinish`;
    const finishTime = Date.now();
    console.log({path, finishTime});

    updateDataAtPath(path, finishTime);
  }
};

export const markClassicLocationAllComplete = ({groupId, locationId}) => {
  if (groupId && locationId) {
    const path = `scavengerhunt/completions/${groupId}/location_v2/allChallenges/${locationId}/completeTime`;
    const completeTime = Date.now();

    console.log('mark all chals complete');

    updateDataAtPath(path, completeTime);
  }
};
